<template>
  <div class="home_container displayBlockClass">
    <!-- Slideshow container -->
    <div  class="slideshow-container" id="home_slideshow_container" v-on:click="plusSlides(1)">

      <!-- Full-width images with number and caption text -->
      <div class="mySlides fade">
        <img alt="home slide"  src="../assets/tr.jpg" style="width:100%">
        <!--<div class="text">Caption Text</div>-->
      </div>

      <div class="mySlides fade">
        <img alt="home slide"  src="../assets/frontpage1.jpg" style="width:100%">
        <!--<div class="text">Caption Two</div>-->
      </div>

      <div class="mySlides fade">
        <img alt="home slide"  src="../assets/frontpage2.jpg" style="width:100%">
        <!--<div class="text">Caption Three</div>-->
      </div>

      <div class="mySlides fade">
        <img alt="home slide"  src="../assets/frontpage3.jpg" style="width:100%">
        <!--<div class="text">Caption Three</div>-->
      </div>

      <div class="mySlides fade">
        <img alt="home slide"  src="../assets/frontpage5.jpg" style="width:100%">
        <!--<div class="text">Caption Three</div>-->
      </div>

      <div class="mySlides fade">
        <img alt="home slide"  src="../assets/frontpage4.jpg" style="width:100%">
        <!--<div class="text">Caption Three</div>-->
      </div>
    </div>
    <br>

    <!-- The dots/circles -->
    <div class="dots" style="text-align:center">
      <span class="dot" v-on:click="currentSlide(1)"></span>
      <span class="dot" v-on:click="currentSlide(2)"></span>
      <span class="dot" v-on:click="currentSlide(3)"></span>
      <span class="dot" v-on:click="currentSlide(4)"></span>
      <span class="dot" v-on:click="currentSlide(5)"></span>
      <span class="dot" v-on:click="currentSlide(6)"></span>
    </div>
  </div>
</template>

<script>
    export default {
      name: "slideshow",
      data () {
        return {
          slideIndex : 1
        }
      },
      mounted: function(){
        this.showSlides(this.slideIndex);
        /*let _this = this;
        setInterval(function(){
          _this.plusSlides(1);
        },10000);*/
        var container = document.querySelector('#home_slideshow_container');
        var listener = SwipeListener(container);
        let _this = this;
        container.addEventListener('swipe', function (e) {
          //console.log(e.detail.directions.left);
          if (e.detail.directions.left) {
            _this.plusSlides(1);
          }else if (e.detail.directions.right) {
            _this.plusSlides(-1);
          }
        });
      },
      methods: {
        plusSlides:function (n) {
          this.showSlides(this.slideIndex += n);
        },
        currentSlide:function (n) {
          this.showSlides(this.slideIndex = n);
        },
        showSlides:function (n) {
          let i;
          let slides = document.getElementsByClassName("mySlides");
          let dots = document.getElementsByClassName("dot");
          if (n > slides.length) {this.slideIndex = 1}
          if (n < 1) {this.slideIndex = slides.length}
          for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
          }
          for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
          }
          slides[this.slideIndex-1].style.display = "block";
          dots[this.slideIndex-1].className += " active";
        }
      }
    }
</script>

<style scoped>
  * {box-sizing:border-box}

  /* Slideshow container */
  .slideshow-container {
    max-width: 1000px;
    position: relative;
    margin: auto;
  }

  /* Hide the images by default */
  .mySlides {
    display: none;
  }

  /* Next & previous buttons */
  .prev, .next {
    cursor: pointer;
    position: absolute;
    top: 50%;
    width: auto;
    margin-top: -22px;
    padding: 16px;
    color: white;
    font-weight: bold;
    font-size: 18px;
    transition: 0.6s ease;
    border-radius: 0 3px 3px 0;
    user-select: none;
  }

  .prev{
    left: 0;
  }

  /* Position the "next button" to the right */
  .next {
    right: 0;
    border-radius: 3px 0 0 3px;
  }

  /* On hover, add a black background color with a little bit see-through */
  .prev:hover, .next:hover {
    background-color: rgba(0,0,0,0.8);
  }

  /* Caption text */
  .text {
    color: #f2f2f2;
    font-size: 15px;
    padding: 8px 12px;
    position: absolute;
    bottom: 8px;
    width: 100%;
    text-align: center;
  }

  /* Number text (1/3 etc) */
  .numbertext {
    color: #f2f2f2;
    font-size: 12px;
    padding: 8px 12px;
    position: absolute;
    top: 0;
  }

  /* The dots/bullets/indicators */
  .dot {
    cursor: pointer;
    height: 10px;
    width: 10px;
    margin: 0 2px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    transition: background-color 0.6s ease;

  }

  .dots{
    margin-top: -19px;
  }

  .active, .dot:hover {
    background-color: #717171;
  }


  /* Fading animation */
  .fade {
    -webkit-animation-name: fade;
    -webkit-animation-duration: .5s;
    animation-name: fade;
    animation-duration: .5s;
  }

  @-webkit-keyframes fade {
    from {opacity: .4}
    to {opacity: 1}
  }

  @keyframes fade {
    from {opacity: .4}
    to {opacity: 1}
  }

  @media only screen and (max-width: 992px) {
    .dot{
      width: 7px;
      height: 7px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/slideshow.vue